import React, { useState } from 'react'
import { Button, DialogModal, Icon } from '../../../components/common'
import Navigator from '../../../components/common/Navigator'
import Horizon1 from '../../../assets/tech-horizon1.png'
import Horizon2 from '../../../assets/tech-horizon2.png'
// import bgimage from '../../../assets/teambg.png'
import { useTranningCalenderDetails } from './api'
import { useNavigate, useParams } from 'react-router-dom'
import PlayIcon from '../../../components/common/icons/PlayIcon'
import { format } from 'date-fns'

// import MultiCarousal from '../../../components/common/Multicarousal/Multicarousal'
import { useAuthStore } from '../../../store/authStore'

type TabId = 'objective' | 'eligibility' | 'program' | 'fee'

interface Tab {
  id: TabId
  label: string
}

interface FeeCard {
  title: string
  oldPrice: string
  newPrice: string
  currency: string
  saved: string
}

// interface FAQItem {
//   question: string
//   answer: string
// }

const tabs: Tab[] = [
  { id: 'objective', label: 'Objective' },
  { id: 'eligibility', label: 'Eligibility' },
  { id: 'program', label: 'Program Structure' },
  { id: 'fee', label: 'Fee' },
]

const tabContent: Record<TabId, string[] | string> = {
  objective: [
    'To instill an entrepreneurial mindset among students, youth, and early-stage entrepreneurs.',
    'To build the capacity of government officials, trainers, and mentors to support enterprise development.',
    'To promote inclusive entrepreneurship through targeted training for women, marginalized communities, and rural populations.',
    'To support sector-specific entrepreneurship, especially in areas like agro-processing, renewable energy, and traditional industries.',
    'To create sustainable platforms for entrepreneurial learning through academic programs and digital initiatives.',
  ],
  eligibility: [
    'Student',
    'Guest',
    'Schools and Colleges',
    'Expert / Mentors',
    'Industry Associations / Enablers',
    'Aspiring Entrepreneur',
    'Existing Entrepreneur',
    'ED Club',
    'Research Institutions and Universities',
  ],
  program: `The objective of the Tech Horizon – Export Import Workshop is to equip participants with comprehensive knowledge and practical skills in international trade, enabling them to navigate the complexities of the export-import business with confidence. The workshop aims to bridge the gap between theoretical understanding and real-world application by covering essential topics such as trade regulations, documentation, logistics, market analysis, digital trade tools, and financial instruments. Whether you're a budding entrepreneur, student, or business professional, this program is designed to empower you with the tools needed to explore global markets, ensure compliance, and grow sustainably in the international business landscape.`,
  fee: `The participation fee for the workshop will be communicated upon registration. Scholarships or discounts may be available for early registrations or group participants.`,
}

// const faqData: FAQItem[] = [
//   {
//     question: 'What is the Tech Horizon – Export Import Workshop about?',
//     answer: `The Tech Horizon – Export Import Workshop is a comprehensive training program designed to provide participants with in-depth knowledge and practical skills related to international trade. It focuses on the complete export-import process, including trade regulations, documentation, market research, logistics, digital tools, and global business strategies. The workshop aims to bridge the gap between theoretical understanding and real-world applications, making it ideal for students, entrepreneurs, and professionals looking to explore or expand in the global market.`,
//   },
//   {
//     question: 'What are the key benefits of attending this workshop?',
//     answer:
//       'Participants gain practical knowledge, expert insights, and networking opportunities to confidently navigate global markets and expand their businesses.',
//   },
//   {
//     question: 'Can students from non-commerce backgrounds apply?',
//     answer:
//       'Yes, the workshop is designed for professionals, students, and entrepreneurs from diverse academic and professional backgrounds.',
//   },
//   {
//     question: 'Will I receive a certificate after completion?',
//     answer:
//       'Yes, all participants who successfully complete the workshop will receive a certificate of participation.',
//   },
// ]

const ProgramDetails: React.FC = () => {
  const { authenticated, roleData } = useAuthStore()
  const [activeTab, setActiveTab] = React.useState<TabId>('objective')
  // const [openIndex, setOpenIndex] = React.useState<number | null>(null)
  const { id } = useParams<{ id: string }>()

  const { data } = useTranningCalenderDetails(id)

  const navigate = useNavigate()

  const [isModalOpen, setIsModalOpen] = useState(false)
  const handleApplyNow = (id: any) => {
    if (authenticated) {
      let allowedRoles: number[] = []

      if (data?.role_id) {
        try {
          if (Array.isArray(data.role_id)) {
            allowedRoles = data.role_id.map((r: any) => Number(r))
          } else if (typeof data.role_id === 'string') {
            const cleaned = data.role_id.trim().replace(/^"|"$/g, '')
            allowedRoles = JSON.parse(cleaned).map((r: any) => Number(r))
          }
        } catch (err) {
          console.error('Error parsing role_id:', err, data?.role_id)
        }
      }

      const userRoleId = Number(roleData?.id)
      if (userRoleId && allowedRoles.includes(userRoleId)) {
        id && navigate(`/departments/learning/form/${id}`)
      } else {
        setIsModalOpen(true)
      }
    } else {
      navigate('/login')
    }
  }
  const formatDate = (dateString: string) => {
    if (!dateString) return ''
    const date = new Date(dateString)
    if (isNaN(date.getTime())) return ''
    const day = String(date.getDate()).padStart(2, '0')
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const year = date.getFullYear()
    return `${day}-${month}-${year}`
  }
  const feeCards: FeeCard[] = [
    {
      title: 'Non-Resident',
      oldPrice: `₹${(Number(data?.non_res_fees) / (1 - Number(data?.discount) / 100)).toFixed(0)}`,
      newPrice: `₹${data?.non_res_fees}`,
      currency: '/ Seat',
      saved: `YOU SAVED ${data?.discount}%`,
    },
    {
      title: 'SC',
      oldPrice: `₹${(Number(data?.sc_fees) / (1 - Number(data?.discount) / 100)).toFixed(0)}`,
      newPrice: `₹${data?.sc_fees}`,
      currency: '/ Seat',
      saved: `YOU SAVED ${data?.discount}%`,
    },
    {
      title: 'ST',
      oldPrice: `₹${(Number(data?.st_fees) / (1 - Number(data?.discount) / 100)).toFixed(0)}`,
      newPrice: `₹${data?.st_fees}`,
      currency: '/ Seat',
      saved: `YOU SAVED ${data?.discount}%`,
    },
    {
      title: 'Resident',
      oldPrice: `₹${(Number(data?.res_fees) / (1 - Number(data?.discount) / 100)).toFixed(0)}`,
      newPrice: `₹${data?.res_fees}`,
      currency: '/ Seat',
      saved: `YOU SAVED ${data?.discount}%`,
    },
  ]
  // const members = data?.mentors || []

  // const handleToggle = (index: number) => {
  //   setOpenIndex(openIndex === index ? null : index)
  // }
  // const handleRedirect = (id: any) => {
  //   id && navigate(`/departments/learning/form/${id}`)
  // }
  const tabImages: Record<TabId, string | null> = {
    objective: Horizon2,
    eligibility: Horizon1,
    program: Horizon2,
    fee: null,
  }

  const renderTabContent = () => {
    const content = tabContent[activeTab]

    if (activeTab === 'fee') {
      return (
        <div>
          <p>{content}</p>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-6">
            {feeCards.map((item, idx) => (
              <div
                key={idx}
                className="border rounded-xl bg-[#FFF6F2] px-14 py-5 text-center hover:shadow-md transition duration-300"
              >
                <h4 className="text-lg font-bold mb-2">{item.title}</h4>
                <div className="text-primaryBlue text-[16px] font-bold mb-1">
                  <span className="line-through text-gray-500 mr-1">
                    {item.oldPrice}
                  </span>
                  <span>{item.newPrice}</span>
                  <span className="text-gray-500">{item.currency}</span>
                </div>
                <div className="text-red-600 text-sm font-semibold mb-2">
                  {item.saved}
                </div>
                <ul className="text-left text-sm text-gray-700 mt-4 space-y-1">
                  <li className="flex items-start gap-2">
                    <Icon
                      name="greentick"
                      className="text-green-500 mt-[2px]"
                    />
                    Full Access To Programme
                  </li>
                  <li className="flex items-start gap-2">
                    <Icon
                      name="greentick"
                      className="text-green-500 mt-[2px]"
                    />
                    Participation Certificate
                  </li>
                </ul>
              </div>
            ))}
          </div>
        </div>
      )
    }

    if (Array.isArray(content)) {
      return (
        <ul className="space-y-3">
          {content.map((point, idx) => (
            <li key={idx} className="flex items-start gap-3">
              <PlayIcon className="text-green-500 mt-1" />
              <span className="text-gray-700 text-[14px] md:text-base">
                {point}
              </span>
            </li>
          ))}
        </ul>
      )
    }

    return (
      <p className="text-gray-700 text-[14px] md:text-base whitespace-pre-line tracking-tighter break-words">
        {content}
      </p>
    )
  }

  return (
    <>
      <div className="lg:w-11/12 mx-auto p-4 lg:p-0 lg:my-8">
        <Navigator title={data?.name} slug="TECH_HORIZON" />
        <h1 className="text-4xl font-semibold text-black mb-2">
          {data?.name
            ? data.name.charAt(0).toUpperCase() + data.name.slice(1)
            : ''}
        </h1>
        <p className="text-sm text-gray-600 mb-4">{data?.location}</p>
        <hr className="border-t-2 border-primaryBlue mb-6" />

        <div className="flex flex-col gap-y-6 mb-8">
          <div className="flex">
            <div className="w-52 font-bold ">Course Timeline</div>
            <div className="w-32">:</div>

            <div className="text-primaryBlue font-bold text-md">
              From {data?.date ? format(new Date(data.date), 'dd-MM-yyyy') : ''}{' '}
              &nbsp; to &nbsp;
              {data?.end_date
                ? format(new Date(data.end_date), 'dd-MM-yyyy')
                : ''}
            </div>
          </div>
          <div className="flex">
            <div className="w-52 font-bold">Location</div>
            <div className="w-32">:</div>
            <div className="text-primaryBlue font-bold text-md">
              {data?.location}
            </div>
          </div>
          {/* <div className="flex">
            <div className="w-52 font-bold">Duration</div>
            <div className="w-32">:</div>
            <div className="text-primaryBlue font-bold text-md">
              {data?.duration}
            </div>
          </div> */}
        </div>

        <div className="grid grid-cols-1 gap-8 lg:items-center mb-12">
          <div>
            <h2 className="text-lg md:text-xl font-semibold text-gray-800 mb-4">
              Unlock Global Markets with Tech-Driven Strategies
            </h2>
            <p className="font-barlow font-normal text-[16px] text-gray-600 mb-6 tracking-tighter">
              Our learning programs are designed to equip you with the skills,
              insights, and knowledge needed to thrive in todays fast-evolving
              world. Whether you re upskilling for your career or exploring new
              fields, our courses offer hands-on experience, expert guidance,
              and real-world relevance.
            </p>
            <p className="font-barlow font-normal text-[16px] tracking-tighter text-gray-600 mb-6">
              Our learning modules combine academic depth with industry
              relevance, creating a dynamic space for students, researchers, and
              professionals to collaborate, innovate, and grow.
            </p>
          </div>
        </div>

        <div className="mb-12 flex flex-col md:flex-row gap-8">
          <div className="w-full md:w-3/5">
            <h2 className="font-barlow font-medium text-[32px] tracking-tighter mb-4">
              Overall Expected Outcome
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-ExtraLightGrey">
              {[
                'Knowledge Of International Trade Policies',
                'Business Communication',
                'Logistics And Supply Chain Management',
                'Hands-On Experience With Government Portals',
                'Customs Clearance And Freight Handling',
                'Awareness Of Export Incentives',
                'Skills In Market Research',
                'Familiarity With Payment Terms',
                'Build And Scale An International Trade Business',
              ].map((item, index) => (
                <div key={index} className="flex items-start gap-3">
                  <Icon name="greentick" className="text-green-500 w-5 h-5" />
                  <span className="text-gray-700 text-sm md:text-base">
                    {item}
                  </span>
                </div>
              ))}
            </div>
          </div>
          <div className="w-full md:w-2/5 flex justify-center">
            <img
              src={data?.image}
              alt="Program Overview"
              className="rounded-lg object-cover max-h-64 md:max-h-full"
            />
          </div>
        </div>
      </div>

      <div className="h-16 flex items-center justify-center bg-red-500 mb-20 font-barlow font-bold text-[16px] text-white tracking-tighter">
        Last Date of Registration: {formatDate(data?.end_date)}
      </div>

      <div className="w-11/12 mx-auto">
        <div className="mb-12">
          <div className="grid grid-cols-2 md:grid-cols-4 border-b border-gray-300 mb-6">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`py-3 px-4 text-center font-barlow font-medium text-[16px] leading-[27px] tracking-tight border-b-2 transition-colors duration-300 ${
                  activeTab === tab.id
                    ? 'text-red-600 border-red-600'
                    : 'text-gray-500 border-transparent hover:text-red-600'
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>

          <div
            className={`grid  gap-10 ${activeTab === 'fee' ? 'md:grid-cols-1 w-[80%]' : 'grid-cols-1 md:grid-cols-2'}`}
          >
            <div>
              <h3 className="text-lg md:text-xl font-semibold mb-2 text-justify">
                {tabs.find((t) => t.id === activeTab)?.label}
              </h3>
              {renderTabContent()}
            </div>

            {activeTab !== 'fee' && tabImages[activeTab] && (
              <div className="flex justify-end">
                <img
                  src={tabImages[activeTab] as string}
                  alt={`${activeTab} illustration`}
                  className="rounded-lg object-cover w-full h-auto max-w-[546px] mt-4"
                />
              </div>
            )}
          </div>
        </div>

        <div className="bg-inputBg border border-gray-200 rounded-xl shadow hover:shadow-lg transition duration-300 overflow-hidden mb-10 max-w-5xl mx-auto">
          <div className="flex flex-col md:flex-row">
            <div className="w-full md:w-3/4 p-6">
              <div className="font-barlow font-semibold text-[25px] leading-[27px] tracking-tight mb-4">
                Shape the Future with Us
              </div>
              <p className="font-barlow font-normal text-[14px] tracking-tight">
                Apply Now to Join a Transformative Partnership Between Industry
                and Academia. Submit Your Application Today and Be Part of a
                Powerful Collaboration Fueled by Innovation and Expertise
              </p>
            </div>
            <div className="flex flex-col lg:p-6 md:w-1/4">
              <div className="w-full flex lg:justify-end xs:justify-center my-8">
                <Button
                  label={'Apply Now'}
                  // onClick={() => handleApplyNow(id)}
                  onClick={() => handleApplyNow(id)}
                  size="common"
                  outlined
                  className="border border-LightGreen text-LightGreen px-8 py-2 rounded hover:bg-LightGreen hover:text-white"
                />
              </div>
            </div>
          </div>
        </div>

        {isModalOpen && (
          <DialogModal
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            title="Permission Required"
            className=""
            body={
              <p className="pb-5">
                You do not have permission to access this form.
              </p>
            }
          />
        )}

        {/* <div className="mb-12">
          <h2 className="font-barlow font-medium text-[32px] tracking-tighter mb-4">
            Mentors & Strategic Partners
          </h2>
          <p className="font-barlow font-semibold text-[21px] leading-[21px] text-[#53514E] tracking-normal mb-2">
            Mentors
          </p>
          <p className="font-barlow text-[14px] text-[#53514E] tracking-tight">
            Our mentors and strategic partners play a vital role in guiding
            innovation, sharing industry insights, and providing the support
            needed to turn ideas into impactful ventures.
          </p>

          <div className=" lg:py-8 md:py-6 sm:py-5 mx-auto">
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-x-6 gap-y-8  ">
              {members.map((member: any, idx: any) => (
                <div
                  key={idx} 
                  className="flex flex-col w-full sm:max-w-[290px] md:max-w-[250px] lg:max-w-[240px] rounded-[16px] overflow-hidden shadow-md bg-white h-full xs:pt-3"
                >
                  <div className="relative h-[200px] w-full bg-[#FDECEE]">
                    <img
                      src={bgimage}
                      alt="pattern"
                      className="absolute top-0 left-0 w-full h-full object-cover opacity-40"
                    />
                    <img
                      src={member.photo} 
                      alt={member.mentor_name} 
                      className="relative h-full w-full object-contain pt-10"
                    />
                  </div>

                  <div className="flex-grow px-4 py-3 bg-gradient-to-b from-[#FFF7F3] to-white">
                    <h3 className="text-sm font-semibold text-gray-900 text-center">
                      {member.mentor_name} 
                    </h3>
                    {member.designation && ( 
                      <p className="text-xs text-gray-700 mt-1 leading-snug text-center">
                        {member.designation}
                      </p>
                    )}
                  </div>
                  <div className="mt-auto px-4 pb-4">
                    <button className="bg-PrimaryOrange text-white border border-PrimaryOrange rounded-sm px-10 py-2 hover:bg-white hover:text-PrimaryOrange w-full">
                      View Profile
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div> */}

        {/* <div className="mb-8">
          <h4 className="text-lg md:text-xl font-semibold mb-4">
            Supporting Partners
          </h4>

          {data?.partners && data.partners.length > 0 ? (
            <MultiCarousal speed={3000} section="partners">
              {data.partners.map((partner: any, index: number) => (
                <div
                  key={`partner-${partner.id}-${index}`}
                  className="flex items-center justify-center px-4 py-2"
                >
                  <img
                    src={partner.logo} 
                    alt={`Partner ${index + 1}`}
                    className="max-h-40 w-auto object-contain mx-auto"
                  />
                </div>
              ))}
            </MultiCarousal>
          ) : (
            <p className="text-gray-500">No partners available</p>
          )}
        </div> */}

        {/* <div className="font-barlow font-medium">
          <div className="text-[32px] tracking-tighter mb-4">
            Frequently Asked Questions
          </div>
          {faqData.map((item, index) => (
            <div
              key={index}
              className="border-b border-gray-200 w-full max-w-3xl"
            >
              <button
                onClick={() => handleToggle(index)}
                className="w-full flex justify-between items-center py-2 text-left"
              >
                <span className="font-barlow font-[12px] text-[14px] text-gray-800">
                  {item.question}
                </span>
                <span className="text-gray-400 text-xl">
                  {openIndex === index ? '▾' : '▴'}
                </span>
              </button>
              {openIndex === index && (
                <div className="pb-4 text-gray-600 font-barlow text-sm leading-relaxed">
                  {item.answer}
                </div>
              )}
            </div>
          ))}
        </div> */}
      </div>
    </>
  )
}

export default ProgramDetails
